// extracted by mini-css-extract-plugin
module.exports = {"labelText":"Switch_labelText__1b2fO","input":"Switch_input__3kTEZ","active":"Switch_active__3M9fr"};